import { Component, ComponentInterface, Host, Prop, JSX, h } from '@stencil/core';
import { transformTagNames } from '../../../global/transform-tag-name';

/**
 * @slot - content
 */
@Component({
  tag: 'wb-subnavigation-fly-in-item',
  styleUrl: 'subnavigation-fly-in-item.scss',
  shadow: true,
})
export class SubnavigationFlyInItemComponent implements ComponentInterface {
  /** marks the item as active */
  @Prop({ reflect: true })
  public active: boolean = false;

  /** renders an anchor tag linked to the passed in URL (fragment) */
  @Prop()
  public href: string | undefined;

  /** can be used in combination with `href` property */
  @Prop()
  public rel: string | undefined;

  /** can be used in combination with `href` property */
  @Prop()
  public target: string | undefined;

  /** The notification state */
  @Prop({ reflect: true })
  public hasNotification: boolean = false;

  private TagNames = transformTagNames(this, 'wb-subnavigation-fly-in-item', ['wb-text']);

  public render(): JSX.Element {
    const { WbText } = this.TagNames;

    return (
      <Host class="wb-subnavigation-fly-in-item">
        {this.href ? (
          <a class="tag" href={this.href} rel={this.rel} target={this.target}>
            <WbText size="m">
              <slot />
            </WbText>
            {this.hasNotification && <span class="notification" />}
          </a>
        ) : (
          <button class="tag" type="button">
            <WbText size="m">
              <slot />
            </WbText>
            {this.hasNotification && <span class="notification" />}
          </button>
        )}
      </Host>
    );
  }
}
